var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('IMPORTING_REPOSITORY')))]),_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }